import { render, staticRenderFns } from "./TokenInfo.vue?vue&type=template&id=1ca8a06b&"
import script from "./TokenInfo.vue?vue&type=script&lang=js&"
export * from "./TokenInfo.vue?vue&type=script&lang=js&"
import style0 from "./TokenInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports